var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.s.selectBodySearchList},_vm._l((_vm.searchList),function(item){return _c('li',{key:item.Id,on:{"click":function($event){return _vm.$emit('apply-search', item)}}},[_vm._v(" "+_vm._s(item.Name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }